<template>
   <v-card width="auto" class="pa-0">
    <v-card-title class="primary">
      <span class=" headline font-weight-regular justify-space-between white--text">
        Codes <span v-if="topicForCodes != undefined">for {{ topicForCodes.name }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-btn color="white" @click="closeTopicCodes()">Close</v-btn>
     
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
         <v-row class="ma-0 pa-0 greyBackground" >
            <v-col cols="12" xs="12" sm="6" md="8">
              <p class="subtitle-1 mt-4 font-weight-medium">
                The <strong>GENERATE NEW CODES</strong> button creates <strong>100</strong> new access codes at a time.
              </p>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" class="text-right mt-2">
              <v-btn class="secondary mr-2" @click="generateTopicKeys()">
                Generate new codes
              </v-btn>
            </v-col>
         </v-row>
          <v-divider></v-divider>
         
          <v-row class="ma-0 pa-0" >
            <v-col cols="6" class="success white--text"
              >Available Codes: {{ computeAvailableCodes() }}
              <v-spacer></v-spacer>
              <v-btn @click="usedFilter = false">Show available</v-btn>
            </v-col>
            <v-col cols="6" class="error white--text"
              >Used Codes: {{ codesList.length - computeAvailableCodes() }}
              <v-spacer></v-spacer>
              <v-btn @click="usedFilter = true">Show used</v-btn></v-col
            >
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="filteredCodes"
                item-key="id"
                single-select
                width="100%"
              >
               <template v-slot:top>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" xs="12" sm="6" md="8">
                      <v-select v-model="dateFilter" hide-details="auto" append-icon="icons8-clock-2" label="Filter by date" :items="datesList" clearable solo dense></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" md="4" class="text-right">
                      <v-btn class="mr-2" color="primary" @click="exportCSVFile(headersCSV, formatExportCodes, 'topic-codes')">
                        <v-icon class="btn-icons">icons8-export-csv</v-icon>
                      </v-btn>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="primary" v-bind="attrs" v-on="on" @click="updateAllIssued()">
                              UPDATE ISSUED CODES 
                          </v-btn>
                        </template>
                        <span>Updates all codes to issued or unissued</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
               </template>
              
                <template v-slot:[`item.createdTimestamp`]="{ item }">
                  <span class="text-capitalize">{{
                    formatDate(item.createdTimestamp)
                  }}</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-row align="end" justify="end" class="mr-1">
                    <v-icon
                      medium
                      class="tableForeground--text font-weight-bold"
                      @click="deleteCode(item)"
                    >
                      icons8-delete-bin
                    </v-icon>
                  </v-row>
                </template>

                <template v-slot:[`item.issued`]="{ item }">
                  <v-checkbox
                    v-model="item.issued"
                    @click="updateIssued(item)"
                  ></v-checkbox>
                </template> </v-data-table
            ></v-col>
          </v-row>
    </v-card-text>
   </v-card>
</template>

<script>
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";

export default {
  name: "Codes",
  data: () => ({
    //topic keys
    codesForm: {
      code: "",
      used: false,
      topicId: "",
      topicName: "",
      userId: "",
      coursesId: "",
      createdBy: "",
      createdByID: "",
      modifiedByID: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
      issued: false,
    },
    headers: [
      {
        text: "Code",
        align: "start",
        filterable: false,
        value: "code",
      },
      { text: "Used", value: "used" },
      { text: "Topic", value: "topicName" },
      // { text: "Used by", value: "userId" },
      { text: "Issued", value: "issued" },
      { text: "Created at", value: "createdTimestamp" },
      { text: "Created By", value: "createdBy" },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        hidden: false,
        align: "end",
      },
    ],
    headersCSV: {
      code: "Code",
      topic: "Topic",
      createdAt: "Created at",
      createdBy: "Created by",
      used: "Used",
      issued: "Issued",
    },
    usedFilter: false,
    dateFilter: "",
    exportCodes: [],
    codesList: [],
    returnedTopic: [],
    users: [],
    editedIssued: -1,
    editedIssuedId: null,
    changeAllIssued: false,
    issuedList: [],
}),
  props: {
    topicIdForCodes: {
      type: String,
      required: true,
    },
    topicForCodes: {
      type: Object,
      required: true,
    },
  },
  watch: {
    topicIdForCodes() {
      var self = this;
      this.readCodesForTopic(self.topicIdForCodes);
    },
  },
  computed: {
    formatExportCodes() {
      this.exportCodes = [];
      for (var i = 0; i < this.filteredCodes.length; i++) {
        var code = this.filteredCodes[i].code;
        var topic = this.filteredCodes[i].topicName;
        var createdAt = this.$moment(
          this.filteredCodes[i].createdTimestamp
        ).format("DD MMM YYYY");
        var createdBy = this.filteredCodes[i].createdBy;
        var used = this.filteredCodes[i].used;
        var issued = this.filteredCodes[i].issued;

        this.exportCodes.push({
          code: code,
          topic: topic,
          createdAt: createdAt,
          createdBy: createdBy,
          used: used,
          issued: issued,
        });
      }
      return this.exportCodes;
    },
    filteredCodes() {
      var date = "";
      return this.codesList.filter((item) => {
        if (!this.usedFilter && !this.dateFilter)
          return item.used === this.usedFilter;
        else if (this.usedFilter && !this.dateFilter) {
          return item.used === this.usedFilter;
        } else if (!this.usedFilter && this.dateFilter) {
          var date = this.$moment(item.createdTimestamp).format("DD MMM YYYY");
          return date === this.dateFilter && item.used == false;
        } else if (this.usedFilter && this.dateFilter) {
          var date = this.$moment(item.createdTimestamp).format("DD MMM YYYY");
          return date === this.dateFilter && item.used === this.usedFilter;
        }
      });
    },
    datesList() {
      var list = [];
      for (var i = 0; i < this.codesList.length; i++) {
        var date = this.$moment(this.codesList[i].createdTimestamp).format(
          "DD MMM YYYY"
        );
        if (!list.includes(date)) {
          list.push(date);
        }
      }
      return list;
    },
  },
  methods: {
    updateAllIssued(){
      var self=this;
      if (self.changeAllIssued == false){
        self.changeAllIssued = true;
        //console.log(self.changeAllIssued + "true");
        for (var i=0; i<self.codesList.length; i++){
          if(self.codesList[i].createdBy === "Claudia Admin" && self.codesList[i].issued === false){
              self.codesList[i].issued = true;
              self.updateIssuedVarsOnDB(self.codesList[i], {issued:self.codesList[i].issued});
              //console.log( self.codesList[i].issued + "for loop true"); 
          }   
        }
      } else {
        self.changeAllIssued = false;
        //console.log(self.changeAllIssued + "false");
        for (var i=0; i<self.codesList.length; i++){
          if(self.codesList[i].createdBy === "Claudia Admin"  && self.codesList[i].issued === true){
              self.codesList[i].issued = false;
              self.updateIssuedVarsOnDB(self.codesList[i], {issued:self.codesList[i].issued});
              //console.log( self.codesList[i].issued + "for loop false"); 
          }   
        }
       }
    },
    updateIssuedVarsOnDB(item, fields){
      var self = this;
      self.$firebase.db
        .collection("codes")
        .doc(item.id)
        .update(fields)
        .catch((error) => {
          // console.log("Error adding document: ", error);
          self.$snotify.error(error);
        });
    },
    updateIssued(item) {
      var self = this;
      self.editedIssued = self.codesList.indexOf(item);
      //console.log(item.issued);
      self.codesForm = Object.assign({}, item);
      self.editedIssuedId = item.id;
      self.$firebase.db
        .collection("codes")
        .doc(self.editedIssuedId)
        .set(self.codesForm)
        .then((docRef) => {
          self.$snotify.info("The issued value was edited.");
        })
        .catch((error) => {
          // console.log("Error adding document: ", error);
          self.$snotify.error(error);
        });
    },
    deleteCode(item) {
      const index = this.codesList.indexOf(item);
      var id = item.id;
      //console.log("ID: " + id);

      this.$snotify.confirm(
        "Are you sure you want to delete this code?",
        "Delete Code",
        {
          titleMaxLength: 250,
          maxOnScreen: 1,
          closeOnClick: false,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            //Yes
            {
              text: "Yes",
              action: (toast) => this.yesAction(id, index, toast),
              bold: false,
            },
            //No
            { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
          ],
        }
      );
    },
    yesAction(id, index, toast) {
      var self = this;
      // delete user from firebase collection
      this.$firebase.db
        .collection("codes")
        .doc(id)
        .delete()
        .then(() => {
          self.$snotify.success("The code was deleted.");
        })
        .catch((error) => {
          self.$snotify.error(error);
        });
      this.codesList.splice(index, 1); // remove user from datatable
      this.$snotify.remove(toast.id);
    },
    createCode() {
      var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var result = "",
        rand;
      for (var i = 0; i < 8; i++) {
        rand = Math.floor(Math.random() * chars.length);
        result += chars.charAt(rand);
      }
      result =
        result.substring(0, 4) + "-" + result.substring(4, result.length);
      return result;
    },
    computeAvailableCodes() {
      var available = 0;
      for (var i = 0; i < this.codesList.length; i++) {
        if (this.codesList[i].used === false) {
          available += 1;
        }
      }
      return available;
    },
    generateTopicKeys() {
      for (var i = 0; i < 100; i++) {
        this.codesForm.code = this.createCode();
        this.codesForm.createdByID = this.$store.getters.currUser.id;
        this.codesForm.createdTimestamp = this.$moment().toISOString();
        this.codesForm.createdBy = this.$store.getters.currUser.fullName;
        this.codesForm.topicId = this.topicIdForCodes;
        this.codesForm.topicName = this.topicForCodes.name;
        this.codesForm.used = false;
        this.codesForm.issued = false;
        //console.log(this.codesForm.code);

        var self = this;

        self.$firebase.db
          .collection("codes")
          .doc()
          .set(self.codesForm)
          .then((Result) => {})
          .catch((err) => {
            // console.log(err);
          });
      }
      self.$snotify.success("100 new codes were generated.");
    },
    //topic keys function
    readCodesForTopic(id) {
      var self = this;
      this.$firebase.db
        .collection("codes")
        .where("topicId", "==", id)
        .onSnapshot((querySnapshot) => {
          self.codesList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.codesList.push(Data);
          });
        });
    },
    //topic keys function
    readUsers() {
      var self = this;
      this.$firebase.db.collection("users").onSnapshot((querySnapshot) => {
        self.users = [];
        var Data = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.users.push(Data);
        });
      });
    },
    formatDate(date) {
      date = this.$moment(date).format("DD MMM YYYY");
      return date;
    },
    // convert object to csv
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    //export table to csv
    exportCSVFile(headers, items, fileTitle) {
      //console.log("headers:" + JSON.stringify(headers, null, 2));

      if (headers && items[0] != headers) {
        items.unshift(headers);
      }
      //.log("items: " + JSON.stringify(items[1], null, 2));
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);
      // console.log(JSON.stringify(csv, null, 2))
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    closeTopicCodes() {
      this.$emit("close-topic-codes");
    },
  },
  created() {
    var self = this;
    this.readCodesForTopic(self.topicIdForCodes);
    this.readUsers();
    //this.readTopicById(self.topicIdForCodes);
  },
};
</script>
